<template>
	<div class="progress-bar">
		<div class="progress-bar__inner" :style="{ width: progress + '%' }" />
	</div>
</template>

<script lang="ts" setup>
interface Props {
	progress: number;
}

const { progress } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.progress-bar {
	box-shadow: 0 0.063rem 0.063rem 0 rgba(35, 18, 4, 0.6);
	background-color: #0b0b0b;
	width: 100%;
	height: 0.2rem;

	&__inner {
		@include background(
			url($path-images + "backgrounds/progress-bar-fill.avif"),
			cover,
			0 0,
			no-repeat
		);
		height: 100%;
	}
}
</style>
